// extracted by mini-css-extract-plugin
export default {"cardWrapper":"BusinessDetailPage_cardWrapper__0OK71","button":"BusinessDetailPage_button__hDAVe"};